import { apiService } from './apiService';
import { apiConstants } from '../constants/apiConstants';

export function createQuickApplication(data) {
  return apiService.call(apiConstants.METHOD_POST, `/fast-applications/create`, data, true);
}
